import { useExperimentVariant } from "@sa-nu/experiments/experiment-context";

import { MainVisual } from "../../../main-visual/main-visual";
import { MainVisualWithIndicator } from "../../../main-visual/main-visual-with-indicator";

type Props = {
  imageUrls: string[];
  altText: string;
  onImageClick: () => void;
  priority: boolean;
};

export function SiteCardGallery(props: Props) {
  const variant = useExperimentVariant("rtr-gallery-indicator");
  return variant === "treatment" ? (
    <TreatmentSiteCardGallery {...props} />
  ) : (
    <ControlSiteCardGallery {...props} />
  );
}

function ControlSiteCardGallery({
  imageUrls,
  altText,
  onImageClick,
  priority,
}: Props) {
  return (
    <MainVisual
      images={imageUrls.map((url) => ({ url }))}
      altText={altText}
      onImageClick={onImageClick}
      heroPriority={priority}
      showThumbnails={true}
    />
  );
}

function TreatmentSiteCardGallery({
  imageUrls,
  altText,
  onImageClick,
  priority,
}: Props) {
  return (
    <MainVisualWithIndicator
      images={imageUrls.map((url) => ({ url }))}
      altText={altText}
      onImageClick={onImageClick}
      heroPriority={priority}
    />
  );
}
